define('controllers/notoperatingasuserwarning',['require'],function(require) {
    return function() {
        $("#hidden_link").fancybox({
            maxWidth: 350,
            maxHeight: 700,
            fitToView: false,
            autoSize: true,
            closeClick: false,
            openEffect: 'none',
            closeEffect: 'none',
            padding: 0
        }).trigger('click');
    };
});

